import React from "react";
import ExportBuilder from "../../components/ExportBuilder/ExportBuilder";
import { useDocumentTitle } from "../../hooks/use-document-title";
import "./ExportCartPage.scss";

const ExportCartPage: React.FC = () => {
  useDocumentTitle("Export Builder");

  return (
    <div className="investor-search-page">
      <div className="page-header">
        Built Your Export
        <div className="page-subheader">
          Format how you want to export your contacts, purchase the data, raise
          money, get back to building!
        </div>
      </div>
      <ExportBuilder />
    </div>
  );
};

export default ExportCartPage;
